const objOptionsDropdown = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1
};

const handleIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const img = entry.target;
      const src = img?.dataset?.src || "";

      if (src) {
        img.src = src;
      }
      observer.unobserve(img);
    }
  });
};

const itemsPerLoad = 40;

// Cache DOM elements
const prodContainer = document.querySelector('.sf-prod__container');
const productSection = document.querySelector('[data-section-type="product-page"]');

function setContainerOverflow(value) {
  if (prodContainer) prodContainer.style.overflow = value;
}

function create_custom_dropdowns() {
  const dropdownFilterOptions = document.querySelectorAll(".dropdown-filter-option");

  dropdownFilterOptions.forEach((select) => {
    const sizeOption = select.querySelectorAll("option")?.length;
    if (sizeOption === 0) {
      const parentOption = select.closest(".main-product__block-custom-properties");
      if (parentOption) parentOption.style.display = "none";
    }
    if (!select.nextElementSibling || !select.nextElementSibling.classList.contains("dropdown-select")) {
      const dropdownSelect = document.createElement("div");
      dropdownSelect.classList.add("dropdown-select", "wide", ...select.classList);
      dropdownSelect.setAttribute("tabindex", "0");
      dropdownSelect.innerHTML = `
                <span class="current"></span>
                <div class="list">
                    <ul></ul>
                </div>
            `;
      select.insertAdjacentElement("afterend", dropdownSelect);

      const dropdown = select.nextElementSibling;
      const options = select.querySelectorAll("option");
      const selectedOption = select.querySelector("option:checked");

      dropdown.querySelector(".current").innerHTML = `
        ${selectedOption?.dataset?.url ? `<img src="${selectedOption?.dataset?.url}" width="50px" loading="lazy" height="50px" style="display: inline-block; margin-right: 5px; width: 100%; height: auto">` : ''}
        ${selectedOption?.dataset?.displayText || selectedOption?.textContent}`;

      const listUl = dropdown.querySelector(".list ul");
      let loadedItemsCount = 0;

      const observerDropdownFilter = new IntersectionObserver(handleIntersection, objOptionsDropdown);

      function loadItems() {
        const fragment = document.createDocumentFragment();
        const start = loadedItemsCount;
        const end = Math.min(start + itemsPerLoad, options.length);
        const newImages = [];

        for (let i = start; i < end; i++) {
          const option = options[i];
          const displayText = option?.dataset?.displayText || "";
          const imgLink = option?.dataset?.url || "";

          const li = document.createElement("li");
          li.className = `option ${option.selected ? "selected" : ""}`;
          li.dataset.value = option.value;
          li.dataset.displayText = displayText;
          li.dataset.url = imgLink;

          li.innerHTML = `
            ${imgLink ? `<img src="https://placehold.co/50x50?text=Tartanvibesclothing" data-src="${imgLink}" loading="lazy" width="50px" height="50px" style="display: inline-block; margin-right: 5px; width: 100%; height: auto">` : ''}
            ${option.textContent}
          `;

          const img = li.querySelector("img[data-src]");
          if (img) newImages.push(img);

          fragment.appendChild(li);
        }

        listUl.appendChild(fragment);

        // Chỉ observe image mới thêm
        newImages.forEach((image) => observerDropdownFilter.observe(image));

        loadedItemsCount += end - start;

        // Gắn scroll event nếu còn items chưa load
        if (loadedItemsCount < options.length) {
          listUl.addEventListener("scroll", handleScroll);
        }
      }

      function handleScroll() {
        if (listUl.scrollTop + listUl.clientHeight >= listUl.scrollHeight - 1) {
          listUl.removeEventListener("scroll", handleScroll);
          loadItems();
        }
      }

      loadItems();

      // Show dropdown after rendering
      const filterWrapper = select.closest(".dropdown-filter");
      if (filterWrapper) filterWrapper.classList.add("is-ready");
    }
  });

  document.querySelectorAll(".dropdown-select").forEach((dropdown) => {
    dropdown.querySelector("ul").insertAdjacentHTML(
      "beforebegin",
      `
            <div class="dd-search">
                <input placeholder="Search here" autocomplete="off" class="dd-searchbox" type="text">
            </div>
        `
    );

    // Gắn event listener thay vì inline onkeyup
    const searchBox = dropdown.querySelector(".dd-searchbox");
    if (searchBox) {
      searchBox.addEventListener("keyup", handleSearchFilter);
    }
  });
}

function handleSearchFilter(event) {
  const searchValue = event.target.value.toLowerCase();
  const dropdown = event.target.closest(".dropdown-select");
  if (!dropdown) return;
  dropdown.querySelectorAll("ul > li").forEach((option) => {
    const text = option.textContent.toLowerCase();
    option.style.display = text.includes(searchValue) ? "block" : "none";
  });
}

document.addEventListener("click", function (event) {
  const target = event.target;
  const dropdownSelect = target.closest(".dropdown-select");

  // Đóng tất cả dropdown khác
  if (!dropdownSelect) {
    document.querySelectorAll(".dropdown-select.open").forEach((dropdown) => {
      dropdown.classList.remove("open");
      dropdown.querySelectorAll(".option").forEach((option) => option.removeAttribute("tabindex"));
    });

    if (prodContainer && prodContainer.style.overflow === "initial") {
      setContainerOverflow("hidden");
    }
    return;
  }

  // Bỏ qua click vào search box
  if (target.classList.contains("dd-searchbox")) {
    return;
  }

  // Xử lý click vào option
  const option = target.closest(".option");
  if (option) {
    const list = option.closest(".list");
    const selected = list.querySelector(".selected");
    if (selected) {
      selected.classList.remove("selected");
    }
    option.classList.add("selected");

    const current = dropdownSelect.querySelector(".current");
    current.innerHTML = `
      ${option.dataset.url ? `<img src="${option.dataset.url}" width="50px" height="50px" style="display: inline-block; margin-right: 5px; width: 100%; height: auto" loading="lazy">` : ''}
      ${option.dataset.displayText || option.textContent}`;

    const select = dropdownSelect.previousElementSibling;
    if (select) {
      select.value = option.dataset.value;
      select.dispatchEvent(new Event("change"));
    }
  }

  // Toggle dropdown open/close
  dropdownSelect.classList.toggle("open");
  if (dropdownSelect.classList.contains("open")) {
    dropdownSelect.querySelectorAll(".option").forEach((opt) => opt.setAttribute("tabindex", "0"));
    const selectedOption = dropdownSelect.querySelector(".selected");
    if (selectedOption) selectedOption.focus();

    setContainerOverflow("initial");
    if (productSection) {
      productSection.style.position = 'relative';
      productSection.style.zIndex = 2;
    }
  } else {
    dropdownSelect.querySelectorAll(".option").forEach((opt) => opt.removeAttribute("tabindex"));
    dropdownSelect.focus();
    setContainerOverflow("hidden");
  }
});

document.addEventListener("keydown", function (event) {
  const dropdownSelect = event.target.closest(".dropdown-select");
  if (!dropdownSelect) return;

  const focusedOption = dropdownSelect.querySelector(".list .option:focus") || dropdownSelect.querySelector(".list .option.selected");

  switch (event.key) {
    case "Enter":
      event.preventDefault();
      if (dropdownSelect.classList.contains("open")) {
        focusedOption?.click();
        setContainerOverflow("hidden");
      } else {
        dropdownSelect.click();
      }
      break;
    case "ArrowDown":
      event.preventDefault();
      if (!dropdownSelect.classList.contains("open")) {
        dropdownSelect.click();
      } else {
        const nextOption = focusedOption?.nextElementSibling;
        if (nextOption) nextOption.focus();
      }
      break;
    case "ArrowUp":
      event.preventDefault();
      if (!dropdownSelect.classList.contains("open")) {
        dropdownSelect.click();
      } else {
        const prevOption = focusedOption?.previousElementSibling;
        if (prevOption) prevOption.focus();
      }
      break;
    case "Escape":
      if (dropdownSelect.classList.contains("open")) {
        dropdownSelect.click();
        setContainerOverflow("hidden");
      }
      break;
  }
});

create_custom_dropdowns();
